import { useContext, useEffect, useState } from 'react'
import { observerHandles } from '../../../handles/Handles';
import { setObserverCallbacks } from './DocViewerVM';
import { OCLandInsightsContext } from '../../../hooks/context/OcLandInsightsContext';
import { PageConfigurationContext } from '../../../hooks/context/PageConfigurationContext';
import { DocLinkListContext } from '../../../hooks/context/DocLinkListContext';
const useDocViewerHook = ({view,OpenPanelCheck}):any[] => {
  const ocLandInsightsDictionaryCtx: any = useContext(OCLandInsightsContext);
  const pageConfigurationCtx: any = useContext(PageConfigurationContext);
  const docLinkListCtx: any = useContext(DocLinkListContext);

  //const [payload, setPayload] = useState([]);
    
    useEffect(()=>{
      //view.when(()=>{
      setObserverCallbacks(view,ocLandInsightsDictionaryCtx.data,docLinkListCtx.set,OpenPanelCheck)
    //})
    },[ocLandInsightsDictionaryCtx.data])
    return docLinkListCtx.data
}

export default useDocViewerHook